module.exports = __webpack_public_path__ + "img/card-placeholder.9b4bd5ad.jpg";